import { render } from "./Amount.vue?vue&type=template&id=0d519c3b&ts=true"
import script from "./Amount.vue?vue&type=script&lang=ts"
export * from "./Amount.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__